@if ({
  product: product$ | async,
  }; as content) {
  @if (content.product) {
    <div class="container-product-compare">
      <div class="form-group m-0">
        <div class="form-check m-0">
          <label class="m-0">
            <input #input type="checkbox" name="compare" [checked]="isChecked" (click)="handlerClick(content.product)" />
            @if (label) {
              <span class="form-check-label">
                {{ label | cxTranslate }}
              </span>
            }
          </label>
        </div>
      </div>
    </div>
  }
}
